// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2NzR4","assignButton":"CreateEditEquipmentSchedule_assignButton__DiKzM"};